import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getSchedulesRidingList = ({ busScheduleId, ...params }) => {
  return api.get(`admin/schedule-riding-list-v2/${busScheduleId}`, {
    params,
  });
};

export const getSchedulesRidingListQueryOptions = params => {
  return queryOptions({
    queryKey: ["schedules-riding-list", params],
    queryFn: () => getSchedulesRidingList(params),
  });
};

export const useSchedulesRidingListQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getSchedulesRidingListQueryOptions(params),
    ...queryConfig,
  });
}; 